const gridCache = {};
const gridBgCache = {};
const magazineCache = {};
const listCache = {};
const listRowHeightCache = {};
const listImageHeightCache = {};
const selectedPictureIdCache = {};
const moreCataloguesCache = {};
let gridPriceExistsCache = {};
let gridTaxExistsCache = {};
let gridOptionsExistsCache = {};
let gridTileHeightCache = {};
let gridNameHeightCache = {};
let gridRowMaxHeightCache = {};
let gridNameMaxHeightCache = {};
let cssPrefixValue = '';

const cache = {
  addGridCache: (productId, url) => {
    gridCache[productId] = url;
  },
  getGridCache: productId => gridCache[productId],
  addGridBgCache: (productId, url) => {
    gridBgCache[productId] = url;
  },
  getGridBgCache: productId => gridBgCache[productId],
  addGridTileHeightCache: (productId, height) => {
    gridTileHeightCache[productId] = height;
  },
  getGridTileHeightCache: productId => gridTileHeightCache[productId],
  addGridNameHeightCache: (productId, height) => {
    gridNameHeightCache[productId] = height;
  },
  getGridNameHeightCache: productId => gridNameHeightCache[productId],
  addGridRowMaxHeightCache: (rowId, height) => {
    gridRowMaxHeightCache[rowId] = height;
  },
  getGridRowMaxHeightCache: rowId => gridRowMaxHeightCache[rowId],
  addGridNameMaxHeightCache: (rowId, height) => {
    gridNameMaxHeightCache[rowId] = height;
  },
  getGridNameMaxHeightCache: rowId => gridNameMaxHeightCache[rowId],
  addMagazineCache: (productId, url) => {
    magazineCache[productId] = url;
  },
  getMagazineCache: productId => magazineCache[productId],
  addListCache: (productId, url) => {
    listCache[productId] = url;
  },
  getListCache: productId => listCache[productId],
  addListRowHeightCache: (productId, height) => {
    listRowHeightCache[productId] = height;
  },
  getListRowHeightCache: productId => listRowHeightCache[productId],
  addListImageHeightCache: (productId, height) => {
    listImageHeightCache[productId] = height;
  },
  getListImageHeightCache: productId => listImageHeightCache[productId],
  getAllCache: () => gridRowMaxHeightCache,
  clearGridRowHeightAndNameHeightCache: () => {
    gridTileHeightCache = {};
    gridNameHeightCache = {};
    gridRowMaxHeightCache = {};
    gridNameMaxHeightCache = {};
    gridPriceExistsCache = {};
    gridTaxExistsCache = {};
    gridOptionsExistsCache = {};
  },
  addSelectedPictureIdToCache: (productId, pictureId, metaData = {}) => {
    selectedPictureIdCache[productId] = {
      pictureId,
      metaData
    };
  },
  getSelectedPictureIdFromCache: productId => selectedPictureIdCache[productId],
  upsertSelectedPictureIdInCache: (productId, pictureId, metaData = {}) => {
    let pictureData = selectedPictureIdCache[productId];
    if (!pictureData) {
      pictureData = {
        pictureId,
        metaData
      };
    }
    pictureData.pictureId = pictureId;
    pictureData.metaData = {
      ...pictureData.metaData,
      ...metaData
    };
    selectedPictureIdCache[productId] = pictureData;
  },
  removeSelectedPictureIdFromCache: productId => {
    delete selectedPictureIdCache[productId];
  },
  addMoreCataloguesToCache: (catalogueId, groupShowcaseId, moreCataloguesList) => {
    const key = `${catalogueId}_${groupShowcaseId}`;
    moreCataloguesCache[key] = moreCataloguesList;
  },
  getMoreCataloguesFromCache: catalogueId => moreCataloguesCache[catalogueId],
  setCssPrefixValue: value => {
    cssPrefixValue = value;
  },
  getCssPrefixValue: () => cssPrefixValue,
  setGridPriceExists: (rowId, priceExists) => {
    gridPriceExistsCache[rowId] = priceExists;
  },
  getGridPriceExists: rowId => gridPriceExistsCache[rowId],
  setGridTaxExists: (rowId, taxExists) => {
    gridTaxExistsCache[rowId] = taxExists;
  },
  getGridTaxExists: rowId => gridTaxExistsCache[rowId],
  setGridOptionsExists: (rowId, optionsExist) => {
    gridOptionsExistsCache[rowId] = optionsExist;
  },
  getGridOptionsExists: rowId => gridOptionsExistsCache[rowId]
};

export default cache;
